import { useMemo } from 'react';

import type { UpdateTaskItemAttrs } from '../taskItemChipsUtils';

type AssignmentTaskItemChipCallbacks = {
    onRemove: () => void;
};

/**
 * Assignment callbacks for task-item chips. Deleting an assignment (or the empty
 * "Assign to" placeholder) clears the assignees and turns off the slot, mirroring
 * the element `removeTaskAssignments` (`showAssignments: false`, `assignments: []`).
 */
export const useAssignmentTaskItemChipCallbacks = ({
    updateAttributes,
    canModifyAssignments,
}: {
    updateAttributes: UpdateTaskItemAttrs;
    canModifyAssignments: boolean;
}): AssignmentTaskItemChipCallbacks =>
    useMemo(
        () => ({
            onRemove: () => {
                if (!canModifyAssignments) return;

                updateAttributes({ assignments: [], showAssignments: false });
            },
        }),
        [canModifyAssignments, updateAttributes],
    );
